import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import { photosShow } from '../../helpers/photosShow';
import { withQuery } from '../../hoc/withGraphql';
import { profilePhotouploadDir } from '../../config';

import { user_Account } from '../../lib/graphql/user';
import defaultPic from '/public/siteImages/defaultPic.jpg';

import s from './Avatar.css';

const Avatar = (props) => {
  const { source = null, title, height = 100, width = 100, className = '', withLink = false, profileId = null, linkClassName = '' } = props;
  const { profilePictureData = { loading: true, userAccount: { picture: null } }, isUser = false, type = 'medium', staticImage = false, } = props;
  const { loading, userAccount } = profilePictureData || {};
  const imageBasePath = photosShow(profilePhotouploadDir);
  const fullImagePath = imageBasePath + type + '_';

  let imgSource = defaultPic;

  if (staticImage) {
    imgSource = source ?? defaultPic;
  } else if (isUser) {
    imgSource = !loading && userAccount?.picture
      ? fullImagePath + userAccount.picture
      : defaultPic;
  } else {
    imgSource = source ? fullImagePath + source : defaultPic;
  }

  const avatarImage = (
    <img
      src={imgSource}
      className={cx(s.imgBackground, className)}
      alt={title}
      height={height}
      width={width}
    />
  );

  return withLink ? (
    <a href={`/users/show/${profileId}`} target="_blank" className={linkClassName} rel="noopener noreferrer">
      {avatarImage}
    </a>
  ) : (
    avatarImage
  );
};

Avatar.propTypes = {
  source: PropTypes.string,
  title: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  withLink: PropTypes.bool,
  profileId: PropTypes.number,
  linkClassName: PropTypes.string,
  profilePictureData: PropTypes.shape({
    loading: PropTypes.bool,
    userAccount: PropTypes.shape({
      picture: PropTypes.string,
    }),
  }),
  isUser: PropTypes.bool,
  type: PropTypes.string,
  staticImage: PropTypes.bool,
};

Avatar.defaultProps = {
  source: null,
  title: '',
  height: 100,
  width: 100,
  className: '',
  withLink: false,
  profileId: null,
  linkClassName: '',
  profilePictureData: {
    loading: true,
    userAccount: {
      picture: null,
    },
  },
  isUser: false,
  type: 'medium',
  staticImage: false,
};

export default compose(
  withStyles(s),
  withQuery(
    user_Account,
    {
      name: 'profilePictureData',
      options: (props) => ({
        fetchPolicy: 'network-only',
        skip: !props.isUser,
        ssr: false,
      }),
    }
  )
)(Avatar);
